import { render } from "./ProspectHistoryView.vue?vue&type=template&id=4256b669"
import script from "./ProspectHistoryView.vue?vue&type=script&lang=js"
export * from "./ProspectHistoryView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__